import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Admin Auth APIs
export const adminLogin = (password) => api.post('/admin/login', { password });
export const adminVerify = () => {
  const token = localStorage.getItem('admin_token');
  if (!token) return Promise.reject(new Error('No token'));
  return api.get('/admin/verify', { headers: { Authorization: `Bearer ${token}` } });
};

// Public APIs
export const getPublishedMagazines = () => api.get('/public/magazines');

// Push Notification APIs
export const getVapidKey = () => api.get('/push/vapid-key');
export const pushSubscribe = (subscription) => api.post('/push/subscribe', subscription);
export const pushUnsubscribe = (subscription) => api.post('/push/unsubscribe', subscription);
export const getPushStats = () => api.get('/push/stats');

// Magazine APIs
export const getMagazines = () => api.get('/magazines');
export const getMagazine = (id) => api.get(`/magazines/${id}`);
export const createMagazine = (data) => api.post('/magazines', data);
export const updateMagazine = (id, data) => api.put(`/magazines/${id}`, data);
export const deleteMagazine = (id) => api.delete(`/magazines/${id}`);

// Article APIs
export const getArticles = (magazineId) => api.get(`/magazines/${magazineId}/articles`);
export const createArticle = (data) => api.post('/articles', data);
export const updateArticle = (id, data) => api.put(`/articles/${id}`, data);
export const deleteArticle = (id) => api.delete(`/articles/${id}`);
export const reorderArticles = (magazineId, articleIds) => api.post(`/magazines/${magazineId}/reorder-articles`, { article_ids: articleIds });

// Template APIs
export const getTemplates = () => api.get('/templates');

// Gallery APIs
export const getGalleryImages = () => api.get('/gallery');
export const addGalleryImage = (data) => api.post('/gallery', data);
export const deleteGalleryImage = (id) => api.delete(`/gallery/${id}`);

// Analytics APIs
export const trackView = (magazineId) => api.post(`/magazines/${magazineId}/track-view`);
export const getMagazineAnalytics = (magazineId) => api.get(`/magazines/${magazineId}/analytics`);
export const getOverallAnalytics = () => api.get('/analytics/overview');

// Publishing APIs
export const scheduleMagazine = (magazineId, date) => api.post(`/magazines/${magazineId}/schedule?scheduled_date=${date}`);
export const publishMagazineNow = (magazineId) => api.post(`/magazines/${magazineId}/publish-now`);
export const unpublishMagazine = (magazineId) => api.post(`/magazines/${magazineId}/unpublish`);

// Subscriber APIs
export const getSubscribers = () => api.get('/subscribers');
export const addSubscriber = (data) => api.post('/subscribers', data);
export const removeSubscriber = (id) => api.delete(`/subscribers/${id}`);
export const bulkAddSubscribers = (subscribers) => api.post('/subscribers/bulk', { subscribers });
export const unsubscribeByEmail = (email) => api.delete(`/subscribers/email/${encodeURIComponent(email)}`);
export const getSubscriberCount = () => api.get('/subscribers/count');

// Email APIs
export const sendSingleEmail = (data) => api.post('/email/send', data);
export const sendBulkEmail = (data) => api.post('/email/send-bulk', data);
export const notifyPublication = (magazineId) => api.post(`/email/notify-publication/${magazineId}`);
export const getEmailStatus = () => api.get('/email/status');

// Email Campaign Analytics APIs
export const getEmailCampaigns = () => api.get('/email/campaigns');
export const getCampaignDetails = (campaignId) => api.get(`/email/campaigns/${campaignId}`);
export const getEmailAnalyticsOverview = () => api.get('/email/analytics/overview');
export const deleteCampaign = (campaignId) => api.delete(`/email/campaigns/${campaignId}`);

// Email Scheduling APIs
export const scheduleEmail = (data) => api.post('/email/schedule', data);
export const getScheduledEmails = () => api.get('/email/scheduled');
export const cancelScheduledEmail = (id) => api.delete(`/email/scheduled/${id}`);
export const getQueueStats = () => api.get('/email/queue-stats');

// AI APIs
export const generateArticle = (data) => api.post('/ai/generate-article', data);
export const generateImage = (data) => api.post('/ai/generate-image', data);

// Share APIs
export const getShareData = (magazineId) => api.get(`/magazines/${magazineId}/share-data`);

// PDF API - returns blob
export const downloadPDF = async (magazineId) => {
  const response = await api.get(`/magazines/${magazineId}/pdf`, {
    responseType: 'blob',
  });
  return response;
};

// Upload image
export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`${API}/upload-image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};

export default api;
